module.exports = __webpack_public_path__ + "static/media/Team17.1bf06735.PNG";